module.exports = __webpack_public_path__ + "img/collect_pic_18.34cf6808.png";